import CheckIcon from "../icons/CheckIcon";

const CheckBox = ({ label, disabled=false, checked, onChange, labelClassName='block text-tlight font-[600] text-[15px] leading-[18px] rubik cursor-pointer user-select-none mt-[-8px] mb-[31px]' }) => {

    return (
        <label className={labelClassName}>
            <div className="relative inline-block w-[20px] h-[20px] me-[12px] !align-top">
                <div className="w-[20px] h-[20px] bg-white border-nborder border-[1px] rounded-[5px] relative inline-block align-middle">
                    {checked && <CheckIcon className="absolute left-[3px] top-[3px]" />}
                </div>
                <input type="checkbox" disabled={disabled} checked={checked} onChange={onChange} className="absolute left-0 top-0 h-full w-full appearance-none cursor-pointer" />
            </div>
            {label}
        </label>
    )

};

export default CheckBox;
